import { checkField, getLangFieldDetail, getLanguageField, openLangInputModal, setInputParams, setLangInputParams } from '@/utils/langUtils'

export default {
  data() {
    return {
      // 当前页面数据多语言字段
      langFieldArr: []
    }
  },
  methods: {
    // 打开多语言字段数据录入框
    async openLangModal(field, require = true) {
      if (!this.checkField(field)) return
      let tableName = this.mainTable
      let { id } = this.model
      // 根据业务id和表名、字段获取本地缓存这种的多语言数组
      let detail = setInputParams({ tableName, field, id })
      let fieldObj = {
        id,
        field,
        tableName,
        require,
        detail
      }
      // 详情才会调接口获取
      if (id) {
        // 判断本地缓存中如果没有则调用接口
        if (!detail || !detail.length) {
          let res = await getLangFieldDetail({ field, id, tableName })
          fieldObj.detail = res
        }
      }
      // 打开数据多语言录入模态框
      openLangInputModal(fieldObj, (data, content) => this.setFieldLangData(data, content))
    },
    // 关闭多语言数据录入模态框取到数据回填到表单
    setFieldLangData({ field, value }) {
      // 设置表单值回填
      this.form.setFieldsValue({
        [ field ]: value
      })
    },
    // 校验是否是多语言字段
    checkField(field) {
      return checkField(field, this.langFieldArr)
    },
    // 获取多语言表单字段
    getLangForm(tableName) {
      getLanguageField(tableName).then(res => {
        this.mainLangItems = res.data
        this.langFieldArr = res.fieldArr
      })
    },
  }
}